import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Coerce } from '@kalidea/kaligraphi';

@Component({
    selector: 'app-shared-icon-button',
    templateUrl: './shared-icon-button.component.html',
    styleUrls: ['./shared-icon-button.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedIconButtonComponent {

    @Coerce('boolean')
    @Input() disabled = false;

    @Input() kalTheme = '';

    @Input() icon = 'add';

}
